import { Source, SourceType } from '../src/constants/Source';

export const getScreenFromUrl = (
  url: URL = new URL(window.location.href),
): SourceType => {
  const firstPathSegment = url.pathname.split('/')[1];
  let screen: SourceType;

  if (firstPathSegment === 'b') {
    screen = Source.boardScreen;
  } else if (firstPathSegment === 'c') {
    screen = Source.cardDetailScreen;
  } else if (firstPathSegment === 'power-ups') {
    screen = Source.powerUpsScreen;
  } else if (/^search/.test(firstPathSegment)) {
    screen = Source.searchResultsScreen;
  } else if (firstPathSegment === 'shortcuts') {
    screen = Source.shortcutsScreen;
  } else if (url.pathname === '/') {
    screen = Source.homeScreen;
  } else {
    screen = Source.unknownScreen;
  }

  return screen;
};
